import React from "react";
import AlertExecution from "@app/model/alert/AlertExecution";
import PriceComparisonAlertExecutionNotificationRowFragment
    from "@app/site/secured/alert-execution/fragment/price-comparison/PriceComparisonAlertExecutionNotificationRowFragment";
import PriceComparisonAlertExecutionNotification from "@app/model/alert/PriceComparisonAlertExecutionNotification";
import PriceComparisonAlertExecutionNotificationOutput
    from "@app/model/alert/output/PriceComparisonAlertExecutionNotificationOutput";
import PriceComparisonAlertRulePricePoint from "@app/model/alert/PriceComparisonAlertRulePricePoint";

const PriceComparisonAlertExecutionUpdatedNotificationsFragment: React.FunctionComponent<{
    alertExecution: AlertExecution,
    notificationOutputs: PriceComparisonAlertExecutionNotificationOutput[],
    marketStateDetailsModal: any
}>
    = ({alertExecution, notificationOutputs, marketStateDetailsModal}) => {
    return <div className="mt-8 bg-white rounded-xl space-y-16 sm:space-y-20 lg:mx-0 p-4 sm:p-10">
        <div>
            <div className="flex items-center justify-between">
                <h2 className="text-base font-semibold leading-6 text-gray-900">
                    Updates Since Previous Run
                </h2>
            </div>
            <div className="mt-1 flow-root">
                <div className="overflow-x-auto">
                    <div className="inline-block min-w-full py-2 align-middle">
                        <table className="min-w-full divide-y divide-gray-300 text-gray-500">
                            <thead>
                            <tr>
                                <th scope="col"
                                    className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">Date
                                </th>
                                <th scope="col"
                                    className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                                    Your Price
                                </th>
                                <th scope="col"
                                    className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                                    {alertExecution.alertOutput.priceComparisonAlertRule.pricePoint === PriceComparisonAlertRulePricePoint.MEDIAN && "Median"}
                                    {alertExecution.alertOutput.priceComparisonAlertRule.pricePoint === PriceComparisonAlertRulePricePoint.MIN && "Least Expensive"}
                                    {alertExecution.alertOutput.priceComparisonAlertRule.pricePoint === PriceComparisonAlertRulePricePoint.MAX && "Most Expensive"}
                                </th>
                                {alertExecution.alertOutput.priceComparisonAlertRule.pricePoint !== PriceComparisonAlertRulePricePoint.MEDIAN  && <th scope="col"
                                                                                                                                                      className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                                    Competitor
                                </th>}
                                <th scope="col"
                                    className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                                    Change Since Last Run
                                </th>
                            </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 bg-white">
                            {notificationOutputs.map((notificationOutput) =>
                                <PriceComparisonAlertExecutionNotificationRowFragment
                                    key={notificationOutput.current.id}
                                    notificationOutput={notificationOutput}
                                    alertExecution={alertExecution}
                                    marketStateDetailsModal={marketStateDetailsModal}
                                    showPreviousRun/>)}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default PriceComparisonAlertExecutionUpdatedNotificationsFragment;